// ==================== #app 移动端入口 ====================
export const appData = {
  title: "掌上吃瓜 · 随时随地追黑料",
  description: "扫码下载每日黑料 App，最新爆料推送不遗漏，离线也能刷瓜田。支持 iOS / Android，每日签到领瓜币换周边。",
  badge: "新版本 v3.8.0 已上线",
};

// ==================== #index 吃瓜专题 (7项) ====================
export const indexItems = [
  {
    id: "idx-1",
    title: "娱乐圈「塌房」全纪录",
    description: "从顶流到素人，近三年娱乐圈塌房事件最全整理，含时间线与后续发展追踪。",
    count: 287,
    icon: "ri-fire-line",
    color: "primary",
    image: "https://readdy.ai/api/search-image?query=dramatic%20dark%20red%20and%20black%20abstract%20composition%20with%20cracked%20texture%2C%20collapsing%20structures%2C%20cinematic%20lighting%2C%20editorial%20style%2C%20high%20contrast%2C%20mysterious%20atmosphere&width=600&height=400&seq=idx-tafang&orientation=landscape",
  },
  {
    id: "idx-2",
    title: "网红圈「人设崩塌」",
    description: "盘点那些精心打造的人设如何在一条爆料下瞬间瓦解，深度还原事件始末。",
    count: 163,
    icon: "ri-ghost-line",
    color: "accent",
    image: "https://readdy.ai/api/search-image?query=shattered%20mirror%20fragments%20floating%20in%20dark%20space%2C%20golden%20cracks%2C%20abstract%20surreal%20composition%2C%20dramatic%20lighting%2C%20editorial%20photography%20style&width=600&height=400&seq=idx-renshe&orientation=landscape",
  },
  {
    id: "idx-3",
    title: "科技圈「大瓜年鉴」",
    description: "从发布会翻车到内部邮件泄露，科技巨头们的那些不可言说的年度大瓜。",
    count: 94,
    icon: "ri-cpu-line",
    color: "primary",
    image: "https://readdy.ai/api/search-image?query=dark%20technological%20abstract%20scene%20with%20glowing%20circuit%20lines%20and%20cracked%20glass%2C%20mysterious%20red%20accents%2C%20cinematic%20lighting%2C%20dramatic%20corporate%20atmosphere&width=600&height=400&seq=idx-tech&orientation=landscape",
  },
  {
    id: "idx-4",
    title: "综艺幕后「潜规则」",
    description: "剪辑操控、剧本安排、选手内定——综艺节目那些不为人知的幕后黑料大起底。",
    count: 218,
    icon: "ri-tv-line",
    color: "accent",
    image: "https://readdy.ai/api/search-image?query=theater%20stage%20behind%20the%20curtains%20with%20dramatic%20red%20spotlight%2C%20mysterious%20silhouettes%2C%20abstract%20cinematic%20composition%2C%20dark%20atmosphere%20with%20warm%20highlights&width=600&height=400&seq=idx-zongyi&orientation=landscape",
  },
  {
    id: "idx-5",
    title: "体育圈「禁药风云」",
    description: "体坛兴奋剂丑闻全记录，从国际赛事到国内联赛，那些被掩盖的真相一一揭开。",
    count: 76,
    icon: "ri-run-line",
    color: "primary",
    image: "https://readdy.ai/api/search-image?query=dark%20stadium%20with%20dramatic%20smoke%20and%20red%20lighting%2C%20mysterious%20athletic%20silhouette%2C%20abstract%20sports%20drama%2C%20cinematic%20moody%20atmosphere&width=600&height=400&seq=idx-sports&orientation=landscape",
  },
  {
    id: "idx-6",
    title: "商界大佬「翻车史」",
    description: "从上市公司到创业明星，商界传奇人物背后的争议与丑闻深度调查合集。",
    count: 142,
    icon: "ri-briefcase-line",
    color: "accent",
    image: "https://readdy.ai/api/search-image?query=dark%20corporate%20skyscraper%20with%20cracked%20glass%20windows%2C%20dramatic%20red%20and%20black%20abstract%20composition%2C%20power%20symbolism%2C%20editorial%20moody%20lighting&width=600&height=400&seq=idx-biz&orientation=landscape",
  },
  {
    id: "idx-7",
    title: "直播圈「剧本揭秘」",
    description: "PK演戏、剧本连麦、假货风波——直播带货背后的流量密码与黑料产业链。",
    count: 305,
    icon: "ri-live-line",
    color: "primary",
    image: "https://readdy.ai/api/search-image?query=dramatic%20streaming%20studio%20setup%20in%20darkness%20with%20red%20ring%20light%20glow%2C%20abstract%20composition%2C%20mysterious%20broadcaster%20silhouette%2C%20editorial%20style&width=600&height=400&seq=idx-live&orientation=landscape",
  },
];

// ==================== #carousel 焦点深扒 (5项，全部可见) ====================
export const carouselItems = [
  {
    id: "car-1",
    tag: "独家深扒",
    title: "某顶流男星私下人设与公开形象截然相反？圈内人士万字爆料全文",
    excerpt: "多位曾与其合作的工作人员联合发声，揭露其在片场、综艺及私下社交中的真实面目。",
    heat: "128万热度",
    time: "3小时前",
    image: "https://readdy.ai/api/search-image?query=dramatic%20silhouette%20of%20a%20person%20behind%20frosted%20glass%20with%20red%20and%20black%20contrast%2C%20paparazzi%20flash%20effect%2C%20cinematic%20noir%20style%2C%20mysterious%20celebrity%20scandal%20atmosphere&width=800&height=500&seq=car-topstar&orientation=landscape",
  },
  {
    id: "car-2",
    tag: "追踪报道",
    title: "直播带货头部主播被曝数据造假，品牌方集体维权索赔过亿",
    excerpt: "涉及虚假销量、刷单团队、退货率异常等多项指控，已有十余家品牌方联合委托律所发起诉讼。",
    heat: "96万热度",
    time: "6小时前",
    image: "https://readdy.ai/api/search-image?query=abstract%20data%20charts%20shattering%20into%20pieces%20with%20dramatic%20red%20lighting%2C%20dark%20corporate%20background%2C%20scandal%20exposure%20theme%2C%20editorial%20photojournalism%20style&width=800&height=500&seq=car-live&orientation=landscape",
  },
  {
    id: "car-3",
    tag: "深度调查",
    title: "娱乐圈「隐形资本」大起底：谁在操控你看到的每一条热搜？",
    excerpt: "深度揭秘娱乐营销公司、水军团队、热搜操控产业链，还原流量背后的资本博弈。",
    heat: "87万热度",
    time: "12小时前",
    image: "https://readdy.ai/api/search-image?query=dark%20boardroom%20with%20puppet%20strings%20and%20red%20spotlights%2C%20abstract%20power%20manipulation%20theme%2C%20cinematic%20noir%20composition%2C%20mysterious%20corporate%20drama&width=800&height=500&seq=car-capital&orientation=landscape",
  },
  {
    id: "car-4",
    tag: "独家爆料",
    title: "某知名综艺节目录制现场冲突完整录音流出，节目组连夜剪辑",
    excerpt: "两位常驻嘉宾因剧本安排爆发激烈争执，现场工作人员手机偷录音频已在圈内疯传。",
    heat: "73万热度",
    time: "18小时前",
    image: "https://readdy.ai/api/search-image?query=abstract%20dramatic%20confrontation%20scene%20with%20two%20silhouettes%20and%20exploding%20red%20light%2C%20dark%20studio%20setting%2C%20cinematic%20tension%2C%20editorial%20style&width=800&height=500&seq=car-conflict&orientation=landscape",
  },
  {
    id: "car-5",
    tag: "年度盘点",
    title: "今年最震撼的十大黑料事件，每一个都让人三观震碎",
    excerpt: "从年初的录音门到年末的豪门争产，我们梳理了今年最具冲击力的十起爆料事件。",
    heat: "65万热度",
    time: "1天前",
    image: "https://readdy.ai/api/search-image?query=dramatic%20explosion%20of%20newspaper%20fragments%20and%20red%20confetti%20in%20dark%20void%2C%20abstract%20year%20review%20theme%2C%20cinematic%20impact%2C%20editorial%20photo%20style&width=800&height=500&seq=car-yearly&orientation=landscape",
  },
];

// ==================== #updates 实时快讯 (7项) ====================
export const updateItems = [
  {
    id: "upd-1",
    time: "刚刚",
    tag: "最新",
    title: "某选秀出道偶像被拍到深夜出入私人会所，经纪公司紧急发声明否认",
    source: "前线瓜友投稿",
  },
  {
    id: "upd-2",
    time: "28分钟前",
    tag: "热议",
    title: "品牌代言人塌房后，品牌方连夜撤下所有物料，违约金或创行业新高",
    source: "品牌渠道消息",
  },
  {
    id: "upd-3",
    time: "1小时前",
    tag: "突发",
    title: "某影视公司CEO涉嫌职务侵占被带走调查，旗下多部待播剧前途未卜",
    source: "财经线人爆料",
  },
  {
    id: "upd-4",
    time: "2小时前",
    tag: "跟进",
    title: "此前被曝税务问题的网红主播正式收到税务部门约谈通知，补税金额或超八位数",
    source: "税务局公告解读",
  },
  {
    id: "upd-5",
    time: "4小时前",
    tag: "辟谣",
    title: "网传某知名导演与女演员不雅视频系AI换脸伪造，原视频已溯源至境外网站",
    source: "技术鉴定报告",
  },
  {
    id: "upd-6",
    time: "6小时前",
    tag: "爆料",
    title: "某头部MCN机构内部考核制度曝光：完不成KPI直接被踢出群聊",
    source: "离职员工投稿",
  },
  {
    id: "upd-7",
    time: "8小时前",
    tag: "深度",
    title: "电竞圈代打产业链暗访：从代练到假赛，一条龙的灰色商业帝国",
    source: "暗访调查组",
  },
];

// ==================== #cards 黑料揭秘 (7项) ====================
export const cardItems = [
  {
    id: "crd-1",
    title: "从顶流到无人问津：一个偶像的坠落只用了72小时",
    description: "当我们复盘整个事件时发现，压垮他的不只是那一条爆料，而是此前积累的无数次粉丝失望与公关失误的总爆发。",
    category: "明星黑料",
    reads: "23.6万",
    comments: 8407,
    image: "https://readdy.ai/api/search-image?query=falling%20star%20dissolving%20into%20dark%20void%20with%20red%20particles%2C%20dramatic%20descent%20abstract%20composition%2C%20cinematic%20moody%20lighting%2C%20editorial%20style&width=600&height=400&seq=crd-fall&orientation=landscape",
  },
  {
    id: "crd-2",
    title: "奶茶店「排队托」日结工资曝光：一天站8小时，时薪堪比白领",
    description: "我们潜入某网红奶茶店的排队队伍，发现超过七成排队者都是被雇佣的托，背后是一条完整的雇托产业链。",
    category: "消费黑幕",
    reads: "19.8万",
    comments: 5621,
    image: "https://readdy.ai/api/search-image?query=long%20queue%20of%20shadowy%20figures%20in%20dark%20urban%20setting%20with%20red%20neon%20glow%2C%20abstract%20consumer%20drama%2C%20cinematic%20street%20photography%20style&width=600&height=400&seq=crd-queue&orientation=landscape",
  },
  {
    id: "crd-3",
    title: "某知名作家被AI检测工具判定为代笔，全书80%内容出自枪手",
    description: "通过最新的文本风格分析技术，该作家近三年的四本畅销书中出现了至少三个不同的创作风格。",
    category: "文化圈黑料",
    reads: "15.2万",
    comments: 3987,
    image: "https://readdy.ai/api/search-image?query=typewriter%20shattering%20into%20digital%20fragments%20with%20red%20and%20black%20contrast%2C%20abstract%20literary%20scandal%2C%20dramatic%20editorial%20composition&width=600&height=400&seq=crd-author&orientation=landscape",
  },
  {
    id: "crd-4",
    title: "婚恋App背后的「杀猪盘」：一份完整的骗局流程拆解手册",
    description: "从注册到转账，骗子如何在两周内完成一次完整的杀猪盘操作？我们拿到了骗子的内部培训资料。",
    category: "网络安全",
    reads: "28.4万",
    comments: 12430,
    image: "https://readdy.ai/api/search-image?query=dark%20digital%20web%20of%20red%20strings%20connecting%20mobile%20phone%20silhouettes%2C%20abstract%20online%20scam%20theme%2C%20cyber%20danger%2C%20cinematic%20dark%20atmosphere&width=600&height=400&seq=crd-scam&orientation=landscape",
  },
  {
    id: "crd-5",
    title: "健身房「跑路」套路全解析：为什么你办的卡永远用不完？",
    description: "从选址、装修、预售到关门，我们还原了一家健身房从开业到跑路的完整循环周期。",
    category: "消费陷阱",
    reads: "11.7万",
    comments: 2856,
    image: "https://readdy.ai/api/search-image?query=empty%20dark%20gym%20with%20abandoned%20equipment%20and%20red%20warning%20light%2C%20dramatic%20consumer%20fraud%20theme%2C%20cinematic%20moody%20composition&width=600&height=400&seq=crd-gym&orientation=landscape",
  },
  {
    id: "crd-6",
    title: "二手平台上那些「女生自用」的手机，背后到底藏着什么？",
    description: '深入调查二手平台上的"女生自用"标签背后，翻新机、组装机、脏机如何被包装成个人闲置。',
    category: "电商黑幕",
    reads: "21.3万",
    comments: 6742,
    image: "https://readdy.ai/api/search-image?query=scattered%20smartphone%20parts%20in%20darkness%20with%20red%20glowing%20circuit%20traces%2C%20abstract%20tech%20fraud%20theme%2C%20cinematic%20dark%20product%20photography&width=600&height=400&seq=crd-phone&orientation=landscape",
  },
  {
    id: "crd-7",
    title: "宠物店「星期猫狗」：买回家活不过一个礼拜的行业秘密",
    description: "部分无良商家靠卖病宠牟取暴利，消费者维权却遭遇索赔无门的困境。我们走访了多家涉事店铺。",
    category: "动物保护",
    reads: "33.9万",
    comments: 15892,
    image: "https://readdy.ai/api/search-image?query=dark%20pet%20shop%20window%20with%20red%20neon%20reflection%20and%20sad%20atmosphere%2C%20abstract%20animal%20welfare%20theme%2C%20cinematic%20noir%20composition&width=600&height=400&seq=crd-pet&orientation=landscape",
  },
];

// ==================== #about 关于每日黑料 (1项) ====================
export const aboutData = {
  title: "关于每日黑料",
  subtitle: "不做谣言的搬运工，只做真相的追光者",
  description: "每日黑料吃瓜网成立于2020年，是国内领先的黑料爆料与吃瓜聚合平台。我们秉持「有料必报、去伪存真」的原则，每天为千万吃瓜爱好者提供最新、最全、最真的热门黑料资讯。",
  stats: [
    { value: "10万+", label: "累计爆料" },
    { value: "500万+", label: "月活瓜友" },
    { value: "99.7%", label: "信息核验率" },
    { value: "24h", label: "实时更新" },
  ],
};

// ==================== #media 吃瓜现场 (5项) ====================
export const mediaItems = [
  {
    id: "med-1",
    title: "独家对话：前顶流经纪人首次公开谈明星包装产业链",
    duration: "18:42",
    views: "156万",
    image: "https://readdy.ai/api/search-image?query=dark%20interview%20setting%20with%20single%20spotlight%20and%20empty%20chair%2C%20red%20dramatic%20lighting%2C%20abstract%20talk%20show%20style%2C%20cinematic%20composition&width=640&height=360&seq=med-agent&orientation=landscape",
  },
  {
    id: "med-2",
    title: "实拍暗访：水军工作室一天刷出十万条评论",
    duration: "12:05",
    views: "203万",
    image: "https://readdy.ai/api/search-image?query=rows%20of%20dark%20computer%20screens%20with%20red%20glowing%20text%20in%20dim%20room%2C%20abstract%20bot%20farm%20scene%2C%20cinematic%20undercover%20style%2C%20mysterious%20tech%20atmosphere&width=640&height=360&seq=med-shuijun&orientation=landscape",
  },
  {
    id: "med-3",
    title: "深度还原：一场价值千万的直播带货翻车事故",
    duration: "24:18",
    views: "178万",
    image: "https://readdy.ai/api/search-image?query=dramatic%20empty%20livestream%20studio%20with%20fallen%20equipment%20and%20red%20error%20signs%2C%20abstract%20broadcast%20failure%2C%20cinematic%20dark%20atmosphere&width=640&height=360&seq=med-livecrash&orientation=landscape",
  },
  {
    id: "med-4",
    title: "圈内人揭秘：综艺剪辑如何把一个素人剪成大反派",
    duration: "15:30",
    views: "131万",
    image: "https://readdy.ai/api/search-image?query=dark%20editing%20room%20with%20timeline%20on%20screen%20and%20red%20scissors%20glow%2C%20abstract%20media%20manipulation%2C%20cinematic%20behind%20the%20scenes%20style&width=640&height=360&seq=med-edit&orientation=landscape",
  },
  {
    id: "med-5",
    title: "年度盘点：那些被黑料改变命运的人后来都怎么样了",
    duration: "32:10",
    views: "267万",
    image: "https://readdy.ai/api/search-image?query=dramatic%20timeline%20of%20floating%20newspaper%20headlines%20in%20darkness%20with%20red%20highlights%2C%20abstract%20year%20review%2C%20cinematic%20montage%20style&width=640&height=360&seq=med-year&orientation=landscape",
  },
];

// ==================== #comments 瓜友热评 (4项) ====================
export const commentItems = [
  {
    id: "cmt-1",
    avatar: "https://readdy.ai/api/search-image?query=abstract%20simple%20avatar%20portrait%20with%20warm%20peach%20tone%20circle%20background%2C%20minimalist%20style%2C%20soft%20lighting%2C%20editorial%20headshot&width=80&height=80&seq=cmt-av1&orientation=squarish",
    username: "吃瓜一线群众",
    time: "2小时前",
    content: "这个圈子水太深了，每次爆出来的瓜都只是冰山一角。但正是因为有这样的平台在坚持深挖，我们才能看到更多真相。加油每日黑料！",
    likes: 2847,
    badge: "铁杆瓜友",
  },
  {
    id: "cmt-2",
    avatar: "https://readdy.ai/api/search-image?query=abstract%20simple%20avatar%20portrait%20with%20warm%20coral%20tone%20circle%20background%2C%20minimalist%20style%2C%20soft%20lighting%2C%20editorial%20headshot&width=80&height=80&seq=cmt-av2&orientation=squarish",
    username: "真相只有一个",
    time: "5小时前",
    content: "之前那篇关于MCN机构的调查我看了三遍，每一个细节都经得起推敲。这种深度内容才是我们需要的好瓜！",
    likes: 1932,
    badge: "爆料达人",
  },
  {
    id: "cmt-3",
    avatar: "https://readdy.ai/api/search-image?query=abstract%20simple%20avatar%20portrait%20with%20warm%20amber%20tone%20circle%20background%2C%20minimalist%20style%2C%20soft%20lighting%2C%20editorial%20headshot&width=80&height=80&seq=cmt-av3&orientation=squarish",
    username: "理性吃瓜bot",
    time: "8小时前",
    content: "建议各位瓜友吃瓜也要保持理性，不传谣不信谣。每日黑料每次都会标注信息来源和可信度，这一点真的很赞。",
    likes: 1563,
    badge: "优质瓜友",
  },
  {
    id: "cmt-4",
    avatar: "https://readdy.ai/api/search-image?query=abstract%20simple%20avatar%20portrait%20with%20warm%20terracotta%20tone%20circle%20background%2C%20minimalist%20style%2C%20soft%20lighting%2C%20editorial%20headshot&width=80&height=80&seq=cmt-av4&orientation=squarish",
    username: "爆爆爱吃瓜",
    time: "12小时前",
    content: "每天蹲在每日黑料刷新已经成了我的生活习惯，比刷微博有意思多了。今天的体育圈瓜真的太炸裂了！",
    likes: 4218,
    badge: "热门评论",
  },
];

// ==================== #topics 热门话题 (10项) ====================
export const topicItems = [
  { id: "tpc-1", name: "塌房预警", heat: "328万", trend: "up", icon: "ri-alert-line" },
  { id: "tpc-2", name: "录音门事件", heat: "267万", trend: "up", icon: "ri-voiceprint-line" },
  { id: "tpc-3", name: "直播带货翻车", heat: "241万", trend: "up", icon: "ri-shopping-cart-line" },
  { id: "tpc-4", name: "代言人解约潮", heat: "198万", trend: "down", icon: "ri-file-close-line" },
  { id: "tpc-5", name: "AI换脸黑产", heat: "175万", trend: "up", icon: "ri-robot-line" },
  { id: "tpc-6", name: "综艺剧本曝光", heat: "163万", trend: "up", icon: "ri-file-text-line" },
  { id: "tpc-7", name: "水军产业链", heat: "142万", trend: "down", icon: "ri-water-flash-line" },
  { id: "tpc-8", name: "网红人设崩塌", heat: "128万", trend: "up", icon: "ri-user-unfollow-line" },
  { id: "tpc-9", name: "税务风波再起", heat: "115万", trend: "up", icon: "ri-money-cny-circle-line" },
  { id: "tpc-10", name: "代写代笔丑闻", heat: "98万", trend: "down", icon: "ri-edit-line" },
];

// ==================== #ranking 黑料热度榜 (5项) ====================
export const rankingItems = [
  {
    id: "rnk-1",
    rank: 1,
    title: "某顶流男星私下人设彻底崩塌，多名圈内人联合爆料",
    heat: "128万",
    trend: "up",
    change: "+32%",
  },
  {
    id: "rnk-2",
    rank: 2,
    title: "直播带货数据造假产业链曝光，品牌方集体维权",
    heat: "96万",
    trend: "up",
    change: "+18%",
  },
  {
    id: "rnk-3",
    rank: 3,
    title: "娱乐圈隐形资本操控热搜机制大揭秘",
    heat: "87万",
    trend: "up",
    change: "+45%",
  },
  {
    id: "rnk-4",
    rank: 4,
    title: "宠物店星期猫狗黑幕调查引发全网愤怒",
    heat: "74万",
    trend: "up",
    change: "+56%",
  },
  {
    id: "rnk-5",
    rank: 5,
    title: "杀猪盘完整骗局流程曝光，被骗者现身说法",
    heat: "68万",
    trend: "down",
    change: "-12%",
  },
];

// ==================== #contact 投稿爆料 (1项) ====================
export const contactData = {
  title: "投稿爆料",
  subtitle: "有料你就来，每一个爆料都可能改变什么",
  description: "我们欢迎所有拥有真实爆料线索的瓜友投稿。你的信息将被严格保密处理，编辑团队会在24小时内完成核实与回复。",
  methods: [
    { icon: "ri-mail-line", label: "投稿邮箱", value: "tips@meiriheiliao.com" },
    { icon: "ri-wechat-line", label: "微信投稿", value: "MRHL_tougao" },
    { icon: "ri-qq-line", label: "QQ群", value: "938271645" },
  ],
  tips: "爆料信息一经采纳并发布，将根据热度给予 500–50000 元不等的稿酬奖励。",
};

// ==================== #features 平台特色 (5项) ====================
export const featureItems = [
  {
    id: "feat-1",
    icon: "ri-shield-check-line",
    title: "三重核验机制",
    description: "每一条爆料都经过AI交叉验证、人工溯源审核和多方信源比对三层核验，确保不传谣。",
  },
  {
    id: "feat-2",
    icon: "ri-flashlight-line",
    title: "24小时快报",
    description: "编辑团队7×24小时在线追踪，热点事件从爆料到发布平均仅需45分钟。",
  },
  {
    id: "feat-3",
    icon: "ri-eye-off-line",
    title: "爆料人保护",
    description: "多层匿名化处理技术，从通信到存储全程加密，确保爆料人身份永不泄露。",
  },
  {
    id: "feat-4",
    icon: "ri-bar-chart-grouped-line",
    title: "热度实时榜",
    description: "基于真实用户互动数据生成的实时热度榜单，杜绝刷量操控，还原真实热度。",
  },
  {
    id: "feat-5",
    icon: "ri-chat-smile-2-line",
    title: "理性吃瓜社区",
    description: "倡导「吃瓜不传谣、爆料不造谣」的社区文化，打造高质量的吃瓜讨论空间。",
  },
];

// ==================== #faq 常见问题 (5项) ====================
export const faqItems = [
  {
    id: "faq-1",
    question: "每日黑料的信息来源是否可靠？",
    answer: "我们建立了三重信息核验机制：AI辅助交叉验证、专业编辑团队人工溯源、多方信源独立比对。每篇爆料均标注信息来源与可信度等级，瓜友可根据标注自行判断。截至目前，我们的内容核验准确率达到99.7%。",
  },
  {
    id: "faq-2",
    question: "如何向每日黑料投稿爆料？",
    answer: "您可以通过顶部导航栏的「投稿爆料」入口查看详细投稿方式。我们支持邮箱、微信和QQ群三种渠道接收爆料，编辑团队会在收到信息后24小时内完成初步核实并回复。",
  },
  {
    id: "faq-3",
    question: "每日黑料的内容更新频率是怎样的？",
    answer: "我们保持全天候实时更新模式。快讯模块每15–30分钟推送最新爆料，深度调查类文章每日至少更新5–7篇，热门专题合集每周更新。首页所有榜单和话题热度数据每小时刷新一次。",
  },
  {
    id: "faq-4",
    question: "如果发现内容失实，如何进行投诉或维权？",
    answer: "我们非常重视内容的真实性和当事人的合法权益。如发现失实内容，请通过「投稿爆料」页面的联系方式提交具体说明与证据材料，我们将在12小时内启动调查核实程序，确认后立即更正并公开致歉。",
  },
  {
    id: "faq-5",
    question: "每日黑料和传统娱乐八卦媒体有什么不同？",
    answer: "不同于传统八卦媒体的捕风捉影，我们坚持「有料必报、去伪存真」的原则。每篇内容都有明确的信息来源标注，拒绝标题党、拒绝断章取义、拒绝捏造虚构。我们做的是有态度的吃瓜平台，而非无底线的谣言工厂。",
  },
];

// ==================== 导航配置 ====================
export const navItems = [
  { id: "nav-home", label: "首页", anchor: "#hero" },
  { id: "nav-index", label: "吃瓜专题", anchor: "#index" },
  { id: "nav-cards", label: "黑料揭秘", anchor: "#cards" },
  { id: "nav-comments", label: "瓜友热评", anchor: "#comments" },
  { id: "nav-features", label: "平台特色", anchor: "#features" },
  { id: "nav-contact", label: "投稿爆料", anchor: "#contact" },
];

// ==================== Hero 数据 ====================
export const heroData = {
  tagline: "今日最热 · 实时追踪",
  h1: "每日黑料 — 全网黑料吃瓜第一站",
  slogan: "有料必报 · 去伪存真 · 每日更新",
  description: "每日黑料吃瓜网是国内领先的黑料爆料与吃瓜资讯聚合平台。我们 24 小时追踪娱乐圈、网红圈、商界、科技圈、体育圈等全领域热门爆料，为千万吃瓜爱好者提供最新鲜、最深度、最真实的黑料资讯。不做谣言的搬运工，只做真相的追光者。当前站内「塌房预警」「录音门事件」「直播带货翻车」三大话题热度持续飙升，更多独家深扒持续更新中。",
  stats: [
    { label: "今日新增爆料", value: "87条" },
    { label: "实时在线瓜友", value: "32.6万" },
    { label: "本月深度调查", value: "214篇" },
  ],
  primaryCta: { label: "立即吃瓜", anchor: "#carousel" },
  secondaryCta: { label: "我要爆料", anchor: "#contact" },
  heroImage: "https://readdy.ai/api/search-image?query=abstract%20dramatic%20dark%20composition%20with%20warm%20red%20and%20deep%20black%20tones%2C%20layered%20geometric%20shapes%20and%20newspaper%20texture%20fragments%2C%20mysterious%20atmosphere%2C%20editorial%20design%20aesthetic%2C%20bold%20contrast%2C%20cinematic%20lighting%20with%20one%20dramatic%20warm%20spotlight&width=800&height=900&seq=hero-main&orientation=portrait",
};